(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('codes', {
            parent: 'app',
            url: '/codes',
            data: {
                authorities: [],
                pageTitle: 'global.menu.codes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/codes/codes.template.html',
                    controller: 'CodesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('codes');
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('payments');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
